import { axiosInstance } from "../../axios/axios";

export const createJobOfferAlert = async (token, data) => {
    return await axiosInstance.post('/api/job-offer-alerts', {
        filters: {
            job_title: data?.job_title
        }
    }, {
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
    .then(function (response) {
        if (response?.data?.errors) {
            return response?.data
        }
        return response?.data
    })
    .catch(function (error) {
        return error.response
    })
}

export const getJobOfferAlerts = (token) => {
    return axiosInstance.get('/api/job-offer-alerts', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export const deleteJobOfferAlert = async (token, alertId) => {
    try {
        const response = await axiosInstance.delete(`/api/job-offer-alerts/${alertId}`, {
            headers: {
                Authorization: 'Bearer ' + token,
            }
        });
        return response;
    } catch (error) {
        console.error('Delete alert error:', error);
        throw error;
    }
}

export const toggleJobOfferAlert = async (token, alertId) => {
    try {
        const response = await axiosInstance.patch(`/api/job-offer-alerts/${alertId}/toggle-active`, {}, {
            headers: {
                Authorization: 'Bearer ' + token,
            }
        });
        return response;
    } catch (error) {
        console.error('Toggle alert error:', error);
        throw error;
    }
}
